export default "__VITE_ASSET__DkC35awB__"